<template>
  <div class="warp">
    <!-- 头部 -->
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
          <div class="top_p">
            <div class="top_cent_p">
              <i class="el-icon-location"></i>
              <el-dropdown trigger="click" class="koaa">
                <!-- <span class="el-dropdown-link" v-if="namee == ''">
              天津市
              <i class="el-icon-arrow-down el-icon--right"></i>
                </span>-->
                <span class="el-dropdown-link" v-if="getCitys[citr].city_name">
                  {{getCitys[citr].city_name}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="koa">
                  <el-dropdown-item
                    v-for="(item,index) in getCitys"
                    :key="index"
                    @click.native="dropdown(item.id,index)"
                  >{{item.city_name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <i class="el-icon-arrow-down icon"></i> -->
            </div>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{name:'login'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li @click="dialogVisible = true">
              <a href="#">登录</a>
            </li>
            <li>|</li>
            <li @click="dialogVisible1 = true">
              <a href="#">注册</a>
            </li>
            <li>
              <a href="https://coc.sqifu.com" target="_blank">商会后台</a>
            </li>
            <router-link :to="{path:'/fuwushang'}" tag="li">
              <a href="#">卖家中心</a>
            </router-link>
            <li>
              <a href="http://zf.sqifu.com">政府机构</a>
            </li>
            <li v-if="citr ==0 ">
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
            <li v-if="citr == 1 ">
              <i class="el-icon-phone"></i>0934--8612991
            </li>
          </ul>
        </div>
      </div>
      <div class="top_china" style="background:#fff;">
        <div class="top_china_cent">
          <div class="top_china_img" @click="logo()">
            <img src="../../assets/img/top_logo.png" alt />
          </div>
          <div class="top_china-sc">
            <p>基于商会的一站式企业服务平台</p>
            <p>|</p>
            <div class="top_china_bot">
              <img src="../../assets/img/top_slogan.png" alt />
            </div>
          </div>
        </div>
      </div>
      <div class="top_botm">
        <div class="top-botm_cent">
          <ul class="top-botm_ul">
            <li style="width: 150px; text-align: left; margin-left:0;" class="lii">
              <a href="#" style="font-size:16px">服务类目</a>
            </li>
            <router-link :to="{name:'home'}" style="margin-left: 58px;" tag="li">
              <a href="#">首页</a>
            </router-link>
            <router-link style="margin-left: 58px;" :to="{name:'zhengwu'}" tag="li">
              <a href="#">政务政策</a>
            </router-link>
            <li>
              <a href="#">商机人脉</a>
            </li>
            <li class="hover_li">
              <a href="#">解决方案</a>
              <div class="top_show">
                <div class="top_show_1">
                  <ul>
                    <li tag="li">
                      <p>
                        <a href="#">商会行业解决方案</a>
                      </p>
                      <p>
                        <a href="#">赋能商会信息化建设</a>
                      </p>
                    </li>
                    <li tag="li">
                      <p>
                        <a href="#">企服行业解决方案</a>
                      </p>
                      <p>
                        <a href="#">助力企业决胜互联网+时代</a>
                      </p>
                    </li>
                    <li tag="li">
                      <p>
                        <a href="#">政企行业解决方案</a>
                      </p>
                      <p>
                        <a href="#">民营企业服务平台建设运营</a>
                      </p>
                    </li>
                    <li tag="li">
                      <p>
                        <a href="#">一站式定制开发解决方案</a>
                      </p>
                      <p>
                        <a href="#">应用类软件定制化开发服务</a>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <router-link :to="{name:'guanyu'}" tag="li">
              <a href="#">关于商企服</a>
            </router-link>
            <!-- <router-link :to="{name:'hezuo'}" tag="li">
              <a href="#">合作代理</a>
            </router-link> -->
          </ul>
        </div>
      </div>
    </div>
    <div class="bread">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="bread_1">
        <el-breadcrumb-item :to="{ path: '/home' }">
          <!-- <img src="../../assets/img/fuwu/nav_btn_home.png" alt=""> -->
          <span style="margin-left: 20px;">商企服首页</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/home' }">
          <span>{{getService.one_category_name}}</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <span>{{getService.two_category_name}}</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <span>{{getService.category_name}}</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 内容 -->
    <div class="content">
      <div class="content_1">
        <div class="content_left">
          <div class="content_left_1">
            <div class="content_left_01">
              <div class="content_left_02" v-show="num==0">
                <img :src="getService.avatar" alt />
              </div>
              <div class="content_left_02" v-show="num==1"></div>
              <div class="content_left_02" v-show="num==2"></div>
              <div class="content_left_02" v-show="num==3"></div>
              <div class="content_left_02" v-show="num==4"></div>
              <ul>
                <li @click="num=0" :class="{active:num==0}">
                  <img :src="getService.avatar" alt />
                </li>
                <li @click="num=1" :class="{active:num==1}"></li>
                <li @click="num=2" :class="{active:num==2}"></li>
                <li @click="num=3" :class="{active:num==3}"></li>
                <li @click="num=4" :class="{active:num==4}"></li>
              </ul>
            </div>
            <div class="content_left_03">
              <p class="content_p">{{getService.service_name}}</p>
              <div class="content_left_jiage">
                <div class="content_left_jiage1">
                  <p class="jiage_p">价格</p>
                  <p
                    style="margin-left:30px;font-size:20px;color:#F7681EFF;font-weight:400;"
                    v-if="getService.is_size ==2"
                  >￥{{getService.price}}</p>
                  <p
                    v-else
                    style="margin-left:30px;font-size:20px;color:#F7681EFF;font-weight:400;"
                    v-for="(item,index) in getService.size_info"
                    :key="index"
                    v-show="nowIndex == index"
                  >￥{{item.price}}</p>
                  <p style="margin-left:10px;font-size:14px;">/ {{getService.size_unit}}</p>
                </div>
                <div class="content_left_jiage2">
                  <p>5.0分</p>
                  <div class="jiage_img">
                    <img src="../../assets/img/fuwu/service list_icon_score10.png" alt />
                    <img src="../../assets/img/fuwu/service list_icon_score10.png" alt />
                    <img src="../../assets/img/fuwu/service list_icon_score10.png" alt />
                    <img src="../../assets/img/fuwu/service list_icon_score10.png" alt />
                    <img src="../../assets/img/fuwu/service list_icon_score10.png" alt />
                  </div>
                </div>
              </div>
              <div class="content_left_xuanze" v-if="getService.is_size ==1">
                <p>规格</p>
                <ul class="guige">
                  <li
                    v-for="(item,index) in getService.size_info"
                    :key="index"
                    @click="toggleTabs(index)"
                    :class="{active:index == nowIndex}"
                  >
                    <a href="#">{{item.size_name}}</a>
                    <img src="../../assets/img/fuwuxiang/service details_btn_gg_sel.png" alt />
                  </li>
                </ul>
              </div>
              <div class="content_left_shu">
                <span>数量</span>
                <el-input-number
                  v-model="num8"
                  controls-position="right"
                  :min="1"
                  :max="1000"
                  class="input2"
                ></el-input-number>
                <span>{{getService.size_unit}}</span>
              </div>
              <div class="content_left_gou">
                <el-button
                  type="primary"
                  class="botton"
                  style=" background: #f7681e;outline: 0; border: 0;width:180px;"
                  @click="goumai()"
                >购买服务</el-button>
              </div>
            </div>
            <div class="xiaochengxu">
              <img src="../../assets/img/fuwuxiang/service details_QR code.png" alt />
            </div>
          </div>
          <div class="content_left_2">
            <div class="content_left_pingj">
              <p :class="{active:0==numm}" @click="numm=0">服务详情</p>
              <p :class="{active:1==numm}" @click="numm=1">用户评价</p>
            </div>
            <div class="content_left_jieshao" v-show="numm==0">
              <p class="content_left_2p">{{getService.description}}</p>
              <div class="content_left_2bot">
                <div v-for="(item,index) in getService.imgs" :key="index">
                  <img :src="imgPath + item.url" alt />
                </div>
              </div>
            </div>
            <div class="content_left_pingj1" v-show="numm==1">
              <div class="content_left_pingj2">
                <div class="content_left_jifen">
                  <p class="jfen_p">综合 评分</p>
                  <img
                    src="../../assets/img/fuwuxiang/service details_icon_score.png"
                    alt
                    class="jfen_img"
                  />
                </div>
                <div class="jfen_div">
                  <div class="jfen_xinxin">
                    <p>5.0</p>
                    <img class="oimg" src="../../assets/img/fuwu/service list_icon_score10.png" alt />
                    <img src="../../assets/img/fuwu/service list_icon_score10.png" alt />
                    <img src="../../assets/img/fuwu/service list_icon_score10.png" alt />
                    <img src="../../assets/img/fuwu/service list_icon_score10.png" alt />
                    <img src="../../assets/img/fuwu/service list_icon_score10.png" alt />
                  </div>
                  <ul class="jfen_ul">
                    <li>
                      完成质量
                      <span>4.8</span>
                    </li>
                    <li>
                      完成速度
                      <span>4.8</span>
                    </li>
                    <li>
                      服务态度
                      <span>4.8</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="one" v-if="data.stateCode == 200">
                <div class="content_left_guzhu">
                  <p class="guzhu_p">雇主印象</p>
                  <ul class="guzhu_ul">
                    <li>沟通顺畅（23）</li>
                    <li>服务周到（74）</li>
                    <li>严谨认真（21）</li>
                    <li>服务质量高（21）</li>
                    <li>细致耐心（14）</li>
                  </ul>
                </div>
                <div
                  class="content_left_pinglou"
                  v-for="(item,index) in getProviderReply"
                  :key="index"
                >
                  <div class="content_left_pinglou1">
                    <div class="pinglou_img">
                      <img :src="item.member_photo" alt />
                    </div>
                    <p>{{item.member_name}}</p>
                  </div>
                  <ul class="pinglou_ul">
                    <li>
                      <img
                        class="onimg"
                        src="../../assets/img/fuwu/service list_icon_score10.png"
                        alt
                      />
                      <img src="../../assets/img/fuwu/service list_icon_score10.png" alt />
                      <img src="../../assets/img/fuwu/service list_icon_score10.png" alt />
                      <img src="../../assets/img/fuwu/service list_icon_score10.png" alt />
                      <img src="../../assets/img/fuwu/service list_icon_score10.png" alt />
                      <span style="font-size:12px; color:#666666FF">5.0</span>
                    </li>
                    <li style="color:#222;">{{item.content}}</li>
                    <li>{{item.create_time}}</li>
                  </ul>
                </div>
                <div class="content_three_1"></div>
              </div>
              <div class="zantu" v-else>
                <img src="../../assets/img/fuwuxiang/service details_default_pj.png" alt />
                <p>暂时还没有评价哦~</p>
              </div>
            </div>
          </div>
        </div>
        <div class="content_right">
          <div class="content_right_1">
            <div class="content_right_01">
              <img :src="provider.avatar" alt />
            </div>
            <p class="right_p">{{provider.providers_name}}</p>
            <div class="right_dian">
              <div class="right_img">
                <img src="../../assets/img/fuwuxiang/fws_icon_tel.png" alt />
                <p>{{provider.phone}}</p>
              </div>
              <div class="right_img">
                <img src="../../assets/img/fuwuxiang/fws_icon_location.png" alt />
                <p>{{provider.address}}</p>
              </div>
              <el-button type="primary" class="botton" @click="centerDialogVisible = true">与TA合作</el-button>
              <el-button
                type="primary"
                class="botton"
                style=" background: #f7681e;outline: 0; border: 0;"
                @click="joinprovider()"
              >加入智囊团</el-button>
            </div>
            <div class="content_right_2">
              <div class="content_right_02">
                <p class="content_right_02p">公司简介</p>
                <p class="content_right_02p2">{{provider.content}}</p>
              </div>
            </div>
          </div>
          <div class="content_right_dianbu">
            <div class="content_right_dianbu1">
              <p class="dianbu">店铺其他服务</p>
              <ul class="content_right_ul">
                <li v-for="(item,index) in providerId" :key="index">
                  <div class="li_div">
                    <div class="li_img">
                      <img :src="'https://ctapi.sqifu.com/image/'+item.header_img" alt />
                    </div>
                    <div class="li_p">
                      <p class="li_p1">{{item.service_name}}</p>
                      <p style="color:#F7681E;font-size:16px">￥{{item.price}}</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="content_right_img">
            <img src="../../assets/img/fuwuxiang/service details_fwbz.png" alt />
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="floor">
      <div class="floor_china">
        <div class="floor_china_1">
          <ul style="margin-left: 0;">
            <p>关于我们</p>
            <li style="margin-top: 24px;">
              <a href="#" @click="about()">关于商企服</a>
            </li>
            <li>
              <a href="#" @click="about()">奖项荣誉</a>
            </li>
            <li>
              <a href="#" @click="about()">商企资讯</a>
            </li>
            <li>
              <a href="#" @click="about()">联系我们</a>
            </li>
          </ul>
          <ul>
            <p>我要入驻</p>
            <li style="margin-top: 24px;" @click="fuwushang()">
              <a href="#">服务商入驻</a>
            </li>
            <li>
              <a href="#" @click="shanghui()">商会入驻</a>
            </li>
            <!-- <li @click="hezuo()">
              <a href="#">代理商合作</a>
            </li> -->
          </ul>
          <ul>
            <p>服务&支持</p>
            <li style="margin-top: 24px;">
              <a href="https://www.aliyun.com/?utm_content=se_1002986587">阿里云</a>
            </li>
            <li>
              <a href="https://cloud.tencent.com/?fromSource=gwzcw.330897.330897.330897">腾讯云</a>
            </li>
            <li>
              <a href="https://c.qq.com/">腾讯创业服务平台</a>
            </li>
          </ul>
        </div>
        <div class="floor_china_2">
          <img src="../../assets/img/bottom_logo_blue.png" alt />
          <span>/ 基于商会的一站式企业服务平台</span>
          <p>免费为商业服务类公司提供线上智能化CRM系统及B2B商城，以其强大的商会会员流量体系帮助企业服务类公司进行拓客。</p>
        </div>
      </div>
    </div>
    <div class="floor_1">
      <p>
        <span><a href="http://beian.miit.gov.cn"  target="_blank" style='color:#85919a'>津ICP备19005305号</a></span>
        <img src="../../assets/img/bottom_icon_filing.png" alt style="margin-top:5px;" />
        <span><a href="http://www.beian.gov.cn"  target="_blank" style='color:#85919a'>公安网备案12010302001745号</a></span>
      </p>
    </div>
    <!--  -->
    <div class="top_hover_block" v-show="seene&&index==currente"></div>
    <!-- <div class="dingbu">
      <ul class="dingbu_1">
        <li>
          <a href="#">小程序</a>
        </li>
        <li>
          <a href="#">下载APP</a>
        </li>
        <li>
          <a href="#">公众号</a>
        </li>
      </ul>
      <div class="dingbu_2"></div>
    </div>-->
    <div class="top_show" v-show="seen&&index==current"></div>
    <el-dialog title :visible.sync="centerDialogVisible" width="660px" center>
      <p slot="title" class="dialog_title">与TA合作</p>
      <div class="dialog_cent">
        <div class="tools-btn">
          <div class="dialog_cent_1">
            <span style="color:red;">*</span> 我需要：
          </div>
          <el-cascader :show-all-levels="false" class="xiala"></el-cascader>
        </div>
        <div class="tools-btn">
          <div class="dialog_cent_1">
            <span style="color:red;">*</span> 补充需求:
          </div>
          <el-input type="textarea" :rows="2" placeholder="详细完整的需求有助于我们更好的为您服务（非必填）" class="inpp"></el-input>
        </div>
        <div class="tools-btn">
          <div class="dialog_cent_1">
            <span style="color:red;">*</span> 预算:
          </div>
          <div class="inppp">
            <el-input placeholder="请输入预算金额" class="inpt"></el-input>
            <p>
              <img src="../../assets/img/fuwuxiang/pop_tips.png" alt />请您输入合理的预算，如不填写，则由服务商进行初步报价。
            </p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="centerDialogVisible = false" class="botton1">提交</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" width="760px" height="473px">
      <div class="login1">
        <div :class="{active:0==num}" @click="num=0">
          <a href="#">登录</a>
        </div>
        <div :class="{active:1==num}" @click="num=1">
          <a href="#">注册</a>
        </div>
      </div>
      <div class="login1_1" v-show="num==0">
        <img src="../../assets/img/pop_bg_login.png" alt class="login1_img" />
        <div class="login1_2">
          <div class="login1_2_left">
            <div class="login1_2_erro1">
              <div class="login1_2_erro" v-show="cang">
                <img src="../../assets/img/pop_icon_error.png" alt />
                <p>手机号格式错误！</p>
              </div>
            </div>
            <div class="login1_2_login">
              <div class="login1_2_tel">
                <el-form>
                  <el-form-item prop="phone" class="pr">
                    <el-input placeholder="请输入手机号" class="input1" v-model="form.phone"></el-input>
                    <button @click="getCode(form)" class="code-btn" :disabled="!show">
                      <span v-show="show">获取验证码</span>
                      <span v-show="!show" class="count">重新发送({{count}})</span>
                    </button>
                  </el-form-item>
                  <el-form-item class="pr" prop="ecord">
                    <el-input placeholder="请输入验证码" class="input1" v-model="form.ecord"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="login1_2_denglu" @click="login()">
                <p>
                  <a href="#">登录</a>
                </p>
              </div>
            </div>
          </div>
          <div class="login1_2_right">
            <img src alt />
          </div>
        </div>
      </div>
      <div class="login2_1" v-show="num==1">
        <div class="login2_1_one">
          <div class="login1_2_erro1">
            <div class="login1_2_erro" v-show="cang">
              <img src="../../assets/img/pop_icon_error.png" alt />
              <p>手机号格式错误！</p>
            </div>
          </div>
          <div class="login2_1_two">
            <el-form>
              <el-form-item class="pr" prop="name">
                <el-input placeholder="请输入姓名" class="input1" v-model="formLogon.name"></el-input>
              </el-form-item>
              <el-form-item prop="phone" class="pr">
                <el-input placeholder="请输入手机号" class="input1" v-model="formLogon.phone"></el-input>
                <button @click="getCode1(formLogon)" class="code-btn" :disabled="!show">
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show" class="count">重新发送({{count}})</span>
                </button>
              </el-form-item>
              <el-form-item class="pr" prop="ecord">
                <el-input placeholder="请输入验证码" class="input1" v-model="formLogon.ecord"></el-input>
              </el-form-item>
              <el-form-item class="pr" prop="enterprise_name">
                <el-input placeholder="请输入公司名称" class="input1" v-model="formLogon.enterprise_name"></el-input>
              </el-form-item>
              <el-form-item class="pr">
                <el-cascader
                  :options="options"
                  :props="defaultParams"
                  :change-on-select="true"
                  :clearable="true"
                  v-model="formLogon.office_address_province_id"
                  @change="handleChange"
                  ref="cascaderAddr"
                  style="width:322px"
                ></el-cascader>
              </el-form-item>
              <el-form-item class="pr" prop="detailed_address">
                <el-input
                  placeholder="请输入公司详细地址"
                  class="input1"
                  v-model="formLogon.detailed_address"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="login_three">
              <img src="../../assets/img/pop_btn_xy_nor.png" @click="munn()" v-show="num1==2" />
              <img src="../../assets/img/pop_btn_xy_sel.png" @click="munn1()" v-show="num1==1" />
              <p>
                我已阅读并同意
                <a href="#" style="color:#007BFF">《商企服平台用户服务协议》</a>
              </p>
            </div>
            <div class="login1_2_denglu" @click="getlogon">
              <p>
                <a href="#">注册</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible1" width="760px" height="473px">
      <div class="login1">
        <div :class="{active:1==num}" @click="num=1">
          <a href="#">登录</a>
        </div>
        <div :class="{active:0==num}" @click="num=0">
          <a href="#">注册</a>
        </div>
      </div>
      <div class="login1_1" v-show="num==1">
        <img src="../../assets/img/pop_bg_login.png" alt class="login1_img" />
        <div class="login1_2">
          <div class="login1_2_left">
            <div class="login1_2_erro1">
              <div class="login1_2_erro" v-show="cang">
                <img src="../../assets/img/pop_icon_error.png" alt />
                <p>手机号格式错误！</p>
              </div>
            </div>
            <div class="login1_2_login">
              <div class="login1_2_tel">
                <el-form>
                  <el-form-item prop="phone" class="pr">
                    <el-input placeholder="请输入手机号" class="input1" v-model="form.phone"></el-input>
                    <button @click="getCode(form)" class="code-btn" :disabled="!show">
                      <span v-show="show">获取验证码</span>
                      <span v-show="!show" class="count">重新发送({{count}})</span>
                    </button>
                  </el-form-item>
                  <el-form-item class="pr" prop="ecord">
                    <el-input placeholder="请输入验证码" class="input1" v-model="form.ecord"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="login1_2_denglu" @click="login()">
                <p>
                  <a href="#">登录</a>
                </p>
              </div>
            </div>
          </div>
          <div class="login1_2_right">
            <img src alt />
          </div>
        </div>
      </div>
      <div class="login2_1" v-show="num==0">
        <div class="login2_1_one">
          <div class="login1_2_erro1">
            <div class="login1_2_erro" v-show="cang">
              <img src="../../assets/img/pop_icon_error.png" alt />
              <p>手机号格式错误！</p>
            </div>
          </div>
          <div class="login2_1_two">
            <el-form>
              <el-form-item class="pr" prop="name">
                <el-input placeholder="请输入姓名" class="input1" v-model="formLogon.name"></el-input>
              </el-form-item>
              <el-form-item prop="phone" class="pr">
                <el-input placeholder="请输入手机号" class="input1" v-model="formLogon.phone"></el-input>
                <button @click="getCode1(formLogon)" class="code-btn" :disabled="!show">
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show" class="count">重新发送({{count}})</span>
                </button>
              </el-form-item>
              <el-form-item class="pr" prop="ecord">
                <el-input placeholder="请输入验证码" class="input1" v-model="formLogon.ecord"></el-input>
              </el-form-item>
              <el-form-item class="pr" prop="enterprise_name">
                <el-input placeholder="请输入公司名称" class="input1" v-model="formLogon.enterprise_name"></el-input>
              </el-form-item>
              <el-form-item class="pr">
                <el-cascader
                  :options="options"
                  :props="defaultParams"
                  :change-on-select="true"
                  :clearable="true"
                  v-model="formLogon.office_address_province_id"
                  @change="handleChange"
                  ref="cascaderAddr"
                  style="width:322px"
                ></el-cascader>
              </el-form-item>
              <el-form-item class="pr" prop="detailed_address">
                <el-input
                  placeholder="请输入公司详细地址"
                  class="input1"
                  v-model="formLogon.detailed_address"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="login_three">
              <img src="../../assets/img/pop_btn_xy_nor.png" @click="munn()" v-show="num1==2" />
              <img src="../../assets/img/pop_btn_xy_sel.png" @click="munn1()" v-show="num1==1" />
              <p>
                我已阅读并同意
                <a href="#" style="color:#007BFF">《商企服平台用户服务协议》</a>
              </p>
            </div>
            <div class="login1_2_denglu" @click="getlogon">
              <p>
                <a href="#">注册</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { joinProvider, createOrder } from "@/http/api";
import { getLoginphone, getLogin, getRegionList, getLogon } from "@/http/api";
export default {
  data() {
    return {
      centerDialogVisible: false,
      seen: false,
      current: 0,
      seene: false,
      currente: 0,
      index: 0,
      num8: 1,
      num: 0,
      numm: 0,
      getService: [],
      imgPath: "http://ctapi.sqifu.com/image/",
      getProviderReply: [],
      data: [],
      nowIndex: 0,
      //登录
      dialogVisible: false,
      dialogVisible1: false,
      num: 0,
      TIME_COUNT: 60, //验证码倒计时60s
      form: {
        phone: "",
        ecord: ""
      },
      formLogon: {
        phone: "",
        ecord: "",
        name: "",
        enterprise_name: "",
        office_address_province_id: "",
        detailed_address: ""
      },
      count: "",
      show: true,
      cang: false,
      num1: 2,
      options: [],
      defaultParams: {
        label: "name",
        value: "id",
        children: "children"
      },
      provider: [],
      providerId: [],
      getCitys: []
    };
  },
  methods: {
    //划过
    munn() {
      this.num1 = 1;
    },
    munn1() {
      this.num1 = 2;
    },
    enter(index) {
      this.seen = true;
      this.current = index;
    },
    leave() {
      this.seen = false;
      this.current = null;
    },
    lever(index) {
      this.seene = true;
      this.currente = index;
    },
    levee() {
      this.seene = false;
      this.currente = null;
    },
    toggleTabs: function(index) {
      this.nowIndex = index;
    },
    getServiceGoodsById(id) {
      this.id = localStorage.getItem("city_id");
      this.$http(
        "https://ctapi.sqifu.com/api/v1/getServiceGoodsById",
        { goods_id: id },
        "post"
      ).then(res => {
        this.getService = res.data.data;
        //综合评价
        this.$http(
          "https://ctapi.sqifu.com/api/v1/getProviderReply",
          {
            city_id: this.id,
            provider_id: this.getService.provider_id,
            page: 1
          },
          "post"
        ).then(res => {
          this.getProviderReply = res.data.data.list;
          this.data = res.data;
        });
        this.$http(
          "https://ctapi.sqifu.com/api/v1/GetManagement_ProviderInfo",
          {
            city_id: this.id,
            provider_id: this.getService.provider_id
          },
          "post"
        ).then(res => {
          this.provider = res.data.data;
        });
        this.$http(
          "https://ctapi.sqifu.com/api/v1/getServiceGoodsByProviderId",
          {
            city_id: this.id,
            provider_id: this.getService.provider_id,
            page: 1
          },
          "post"
        ).then(res => {
          this.providerId = res.data.data.data;
        });
      });
    },
    goumai(nowIndex, num8) {
      var numm = this.getService.price * this.num8;
      this.token = localStorage.getItem("token");
      this.$http(
        "https://coc.sqifu.com/WebProgram/Base/checklogin",
        {
          token: this.token
        },
        "post"
      ).then(res => {
        if (res.data.errcode === 20001) {
          alert("请先登录");
        } else {
          createOrder({
            token: this.token,
            goods_price: numm,
            goods_id: this.getService.id,
            provider_id: this.getService.provider_id,
            is_demand: 1,
            goods_num: this.num8,
            size_name: this.getService.size_name,
            size_unit: this.getService.size_unit,
            demand_title: this.getService.demand_title
          }).then(res => {
            this.createorder = res.data.data;
            // if (this.getService.is_size == 1) {
            //   this.$router.push({
            //     name: "dingdan",
            //     query: {
            //       goods_price: this.getService.size_info[this.nowIndex].price,
            //       goods_id: this.getService.id,
            //       provider_id: this.getService.provider_id
            //     }
            //   });
            // } else if (this.getService.is_size == 2) {
            //   this.$router.push({
            //     name: "dingdan",
            //     query: {
            //       goods_price: this.getService.price,
            //       goods_id: this.getService.id,
            //       provider_id: this.getService.provider_id
            //     }
            //   });
            // }
            this.$router.push({
              name: "dingdan",
              query: {
                id: this.createorder.id
              }
            });
          });
        }
      });
    },
    getGoodsCountByProvider(getService) {
      this.id = localStorage.getItem("city_id");
      this.$http(
        "https://ctapi.sqifu.com/api/v1/getGoodsCountByProvider",
        {
          city_id: this.id,
          provider_id: this.getService.provider_id
        },
        "post"
      ).then(res => {});
    },
    joinprovider(getService) {
      this.token = localStorage.getItem("token");
      joinProvider({
        token: this.token,
        provider_id: this.getService.provider_id
      }).then(res => {
        if (res.data.errcode === 200) {
          this.$message({
            message: "加入成功",
            type: "success"
          });
        }
      });
    },

    logo() {
      this.$router.push({
        name: "home"
      });
    },
    //登录
    getCode(form) {
      if (!/^1[34578]\d{9}$/.test(this.form.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.form.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.form.phone }).then(res => {});
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    login() {
      if (this.form.ecord == "") {
        this.$message({
          message: "请输入验证码"
        });
      } else {
        getLogin({
          phone: this.form.phone,
          ecord: this.form.ecord
        }).then(res => {
          this.login_login = res.data;
          if (res.data.errcode === 200) {
            this.dialogVisible = false;
            this.$message({
              message: "登录成功",
              type: "success"
            });
            this.$router.push({
              name: "home",
              query: {
                id: res.data.data.name,
                idimg: res.data.data.photo,
                token: res.data.data.token
              }
            });
            localStorage.setItem("name", res.data.data.name);
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("phone", res.data.data.phone);
            localStorage.setItem("photo", res.data.data.photo);
            localStorage.setItem("member_id", res.data.data.member_id);
            localStorage.setItem("is_service", res.data.data.is_service);
          } else if (res.data.errcode == 406) {
            this.$message({
              message: "账号信息不存在，请先注册"
            });
          }
        });
      }
    },
    //注册并登录
    getCode1(formLogon) {
      if (!/^1[34578]\d{9}$/.test(this.formLogon.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.formLogon.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.formLogon.phone }).then(res => {});
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    getlogon() {
      getLogon({
        name: this.formLogon.name,
        phone: this.formLogon.phone,
        ecord: this.formLogon.ecord,
        enterprise_name: this.formLogon.enterprise_name,
        office_address_province_id: this.formLogon.office_address_province_id,
        detailed_address: this.formLogon.detailed_address
      }).then(res => {
        this.logon_logon = res.data.errcode;
        if (res.data.errcode == 200) {
          this.$router.push({
            name: "home",
            query: {
              id: this.formLogon.name
            }
          });
          localStorage.setItem("name", this.formLogon.name);
          localStorage.setItem("is_service", res.data.data.is_service);
        }
        if (res.data.errcode === 20001) {
          this.$message({
            message: "该手机号已经是会员",
            type: "success"
          });
        }
      });
    },
    handleChange(value) {
      let labels = this.$refs["cascaderAddr"].currentLables;
    },
    getRegion() {
      getRegionList({}).then(res => {
        this.options = res.data.data;
      });
    },
    checlogin() {
      this.token = localStorage.getItem("token");
      this.$http(
        "https://coc.sqifu.com/WebProgram/Base/checkislogin",
        {
          token: this.token
        },
        "post"
      ).then(res => {
        if (res.data.errcode === 20001) {
          this.$emit("header", false); //是否显示头部
        } else {
          this.$emit("header", true); //是否显示头部
        }
      });
    },
    getCity() {
      this.$http("https://ctapi.sqifu.com/api/v1/getCityList", {}, "post").then(
        res => {
          this.getCitys = res.data.data;
        }
      );
    },
    dropdown(id, index) {
      this.citr = index;
      localStorage.setItem("city_id", id);
      localStorage.setItem("citr", this.citr);
      this.$router.go(0);
    },
    about() {
      this.$router.push({
        name: "guanyu"
      });
    }
    // this.token = localStorage.getItem("token");
  },
  created() {
    var id = this.$route.query.id;
    this.getServiceGoodsById(id);
    this.token = localStorage.getItem("token");
    this.getGoodsCountByProvider();
    this.getRegion(); //城市
    this.checlogin();
    this.citr = localStorage.getItem("citr");
    this.getCity();
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.lii {
  height: 40px;
  background: #0812d8;
}

.dialog_cent {
  width: 100%;
  height: 218px;
}

.dialog_cent_1 {
  width: 100px;
  height: 40px;
  float: left;
  line-height: 32px;
  font-size: 14px;
}

.xiala {
  width: 190px;
  height: 38px;
  float: left;
}

.inpp {
  width: 480px;
  height: 96px;
}

.inppp {
  width: 361px;
  height: 60px;
  float: left;
}

.inpt {
  width: 190px;
}

.inppp p {
  margin-top: 5px;
  color: #f7681eff;
  font-size: 12px;
}

.tools-btn {
  overflow: hidden;
  margin-top: 24px;
}
.floor {
  width: 100%;
  background: #2d3236;
}

.floor_china {
  width: 1200px;
  height: 224px;
  margin: 0 auto;
  overflow: hidden;
}

.floor_china_1 {
  width: 750px;
  height: 104px;
  border-right: 1px solid #85919a;
  margin: 60px 0 0 0;
  float: left;
}

.floor_china_1 ul {
  float: left;
  margin-left: 180px;
}

.floor_china_1 li {
  color: #85919a;
  font-size: 14px;
}

.floor_china_1 p {
  color: #fff;
}

.floor_china_2 {
  width: 365px;
  height: 104px;
  float: right;
  margin: 60px 0 0 0;
}

.floor_china_2 span {
  color: #ffffff;
  font-size: 14px;
}

.floor_china_2 p {
  color: #85919a;
  font-size: 14px;
  margin-top: 21px;
}

.top_hover {
  width: 150px;
  height: 426px;
  background: #323445;
  position: absolute;
}

.floor_1 {
  width: 100%;
  height: 56px;
  background: #efefef;
}

.floor_1 p {
  text-align: center;
  line-height: 56px;
  color: #85919a;
  font-size: 14px;
}

.top_hover p {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #414354;
}

.top_hover p a {
  text-align: left;
  margin: 0 0 0 28px;
  color: #fff;
  text-align: center;
  line-height: 60px;
  font-size: 18px;
}

.top_hover p i {
  width: 6.3px;
  height: 12px;
  float: right;
  padding: 23px 20px;
  color: #fff;
}

.top_hover_block {
  width: 522px;
  height: 499px;
  background: #999;
  position: absolute;
  top: 164px;
  left: 50%;
  margin-left: -450px;
}
.top_hover p:hover {
  background: #fff;
  color: #007bff;
}

.top_hover p:hover i {
  color: #007bff;
}

.top_hover p:hover a {
  color: #007bff;
}

.top_hover p:hover .top_hover_block {
  display: block;
}

.lii a {
  margin: 0 0 0 30px;
  color: #fff;
  font-size: 14px;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
  background: #f4f5f9;
}

.top {
  width: 100%;
  background: #f5f6fa;
  position: fixed;
  z-index: 1;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.top_cent_p {
  font-size: 14px;
  color: #007bff;
  line-height: 40px;
  float: left;
}

.icon {
  color: #000;
}

.top_ul {
  width: auto;
  height: auto;
  float: right;
  display: flex;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}

.top_china {
  width: 100%;
  overflow: hidden;
  margin-top: 40px;
}

.top_china_cent {
  width: 1200px;
  margin: 0 auto;
}

.top_china_img {
  padding: 19px 0;
  float: left;
}

.top_china_scout {
  width: 448px;
  height: 44px;
  background: #007bff;
  float: left;
  margin: 19px 0;
  border-radius: 5px;
  margin-right: 11px;
}

.input {
  width: 348px;
  height: 38px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  outline: none;
  border: 0;
  margin: 3px 0 0 3px;
  font-size: 16px;
  float: left;
}

.btn {
  width: 97px;
  height: 44px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  outline: none;
  border: 0;
  background: #007bff;
  font-size: 16px;
  color: #fff;
}

.butoon {
  width: 150px;
  height: 44px;
  margin: 19px 0;
  background: #f7681e;
  outline: 0;
  border: 0;
  font-size: 16px;
}

.top_china-sc {
  float: right;
}

.top_china-sc p {
  float: left;
  line-height: 104px;
  padding: 0 10px;
  font-size: 14px;
  color: #b2b2b2;
}

.top_china_bot {
  width: 150px;
  height: 44px;
  float: left;
  margin-top: 40px;
}

.top_botm {
  width: 100%;
  height: 40px;
  background: #005aff;
}

.top-botm_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}
.top-botm_ul li {
  width: 100px;
  height: 40px;
  float: left;
  margin-left: 40px;
  line-height: 40px;
  text-align: center;
}

.top-botm_cent ul li a {
  color: #fff;
  font-size: 16px;
}

.top-botm_ul li:hover {
  background: #0812d8;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
  background: #fff;
}

.dingbu {
  width: 50px;
  height: 295px;
  position: fixed;
  top: 64%;
  left: 95%;
}

.dingbu_1 {
  width: 50px;
  height: 235px;
  background: #fff;
  border-radius: 5px;
  overflow: hidden;
}

.dingbu_1 li {
  width: 29px;
  height: 56px;
  border-bottom: 1px solid #e5e8ed;
  margin: 0 auto;
  font-size: 14px;
  text-align: center;
}

.dingbu_1 li a {
  margin-top: 10px;
  color: #666666;
}

.dingbu_2 {
  width: 50px;
  height: 60px;
  background: #005aff;
  margin-top: 10px;
  border-radius: 5px;
}

.top_show {
  width: 100%;
  height: 280px;
  background: #fff;
  position: absolute;
  top: 164px;
  left: 0;
  position: fixed;
}

.kong {
  width: 100%;
  height: 184px;
}

.bread {
  width: 100%;
  height: 48px;
  background: #fff;
}

.bread_1 {
  width: 1200px;
  height: 48px;
  margin: 0 auto;
  line-height: 48px;
}

.content {
  width: 100%;
  margin-top: 20px;
  overflow: hidden;
}

.content_1 {
  width: 1200px;
  margin: 0 auto;
}

.content_left {
  width: 940px;
  height: auto;
  float: left;
  overflow: hidden;
}
.content_right {
  width: 240px;
  height: auto;
  float: right;
}

.content_left_1 {
  width: 100%;
  height: 462px;
  background: #fff;
  overflow: hidden;
  position: relative;
}

.content_right_1 {
  width: 100%;
  height: 635px;
  background: #fff;
  overflow: hidden;
}

.content_right_01 {
  width: 208px;
  height: 208px;
  margin: 20px 0 11px 16px;
}

.content_right_01 img {
  width: 208px;
  height: 208px;
}

.right_p {
  width: 200px;
  height: 24px;
  margin: 0 auto;
  font-size: 14px;
  color: #222222;
  font-weight: bold;
}

.right_dian {
  width: 200px;
  height: 160px;
  margin: 0 auto;
  border-bottom: 1px solid #e4e4e4;
}
.right_img {
  margin-top: 15px;
}

.right_img img {
  float: left;
}

.right_img p {
  width: 164px;
  height: 30px;
  font-size: 14px;
  margin-left: 5px;
  float: left;
}

.botton {
  width: 90px;
  height: 40px;
  margin-top: 34px;
  font-size: 12px;
  background: #007bffff;
  outline: 0;
  border: 0;
}

.botton1 {
  width: 180px;
  height: 44px;
  margin-top: 34px;
  font-size: 12px;
  background: #007bffff;
  outline: 0;
  border: 0;
}

.dialog_title {
  height: 60px;
  color: #222222ff;
  font-size: 18px;
  font-weight: 900;
}

.content_right_2 {
  width: 100%;
  height: auto;
  margin-top: 20px;
}
.content_right_02 {
  width: 208px;
  height: 200px;
  margin: 0 auto;
}

.content_right_02p {
  font-size: 14px;
  font-weight: bold;
  color: #000;
}

.content_right_02p2 {
  color: #666666ff;
  font-size: 12px;
  margin-top: 12px;
}

.content_right_dianbu {
  width: 240px;
  height: 563px;
  margin-top: 20px;
  background: #fff;
  overflow: hidden;
}

.content_right_dianbu1 {
  width: 208px;
  height: auto;
  margin: 20px auto;
}

.dianbu {
  font-size: 14px;
  font-weight: bold;
}

.content_right_ul li {
  width: 208px;
  height: 84px;
  border-bottom: 1px solid #e4e4e4ff;
  margin-top: 20px;
}

.li_div {
  width: 208px;
  height: 62px;
  margin-bottom: 16px;
}

.li_img {
  width: 78px;
  height: 62px;
  background: #005aff;
  float: left;
}

.li_img img {
  width: 78px;
  height: 62px;
}

.li_p {
  width: 121px;
  height: 62px;
  float: left;
}

.li_p p {
  font-size: 12px;
  line-height: 21px;
  margin-left: 5px;
}

.li_p1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.content_right_img {
  margin-top: 20px;
}

.content_left_2 {
  width: 940px;
  height: 1809px;
  background: #fff;
  margin-top: 30px;
  overflow: hidden;
  margin-bottom: 114px;
}

.content_left_01 {
  width: 300px;
  height: 320px;
  margin: 30px 0 0 30px;
  float: left;
}

.content_left_02 {
  width: 300px;
  height: 240px;
}

.content_left_02 img {
  width: 300px;
  height: 240px;
}

.content_left_01 ul {
  margin-top: 12px;
  display: flex;
}

.content_left_01 li {
  width: 54px;
  height: 43px;
  /* background: #000; */
  margin-left: 5px;
}

.content_left_01 li img {
  width: 54px;
  height: 43px;
}

.content_left_03 {
  width: 550px;
  height: 390px;
  float: left;
  margin: 30px 0 0 30px;
}

.content_p {
  font-size: 18px;
  color: #222222;
  font-weight: 400;
  line-height: 30px;
}

.content_left_jiage {
  width: 100%;
  height: 88px;
  background: #f4f5f9ff;
  margin-top: 19px;
  display: flex;
}

.content_left_jiage1 {
  width: 420px;
  height: 48px;
  border-right: 1px solid #e4e4e4ff;
  margin-top: 20px;
  line-height: 48px;
  display: flex;
}

.content_left_jiage2 {
  width: 130px;
  height: 48px;
}

.jiage_p {
  margin-left: 15px;
  font-size: 14px;
}

.content_left_jiage2 p {
  margin: 26px 0 0 45px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(102, 102, 102, 1);
}

.jiage_img {
  margin-left: 19px;
}

.content_left_xuanze {
  width: 552px;
  height: 88px;
  margin-top: 10px;
}

.content_left_xuanze p,
.content_left_shu span {
  font-size: 14px;
  float: left;
  margin: 20px 0 0 15px;
}

.content_left_xuanze ul {
  width: 500px;
  float: left;
}

.content_left_xuanze ul li {
  float: left;
  padding: 10px;
  border: 1px solid #e4e4e4ff;
  margin: 10px 0 0 15px;
  border-radius: 5px;
  color: #222222ff;
  font-size: 14px;
  position: relative;
}

.content_left_xuanze ul li a {
  color: #222222ff;
}

/* .content_left_xuanze ul li:first-child {
  border: 1px solid #f7681eff;
} */

.content_left_xuanze ul li img {
  position: absolute;
  bottom: 0;
  right: 0;
  display: none;
}

.xiaochengxu {
  position: absolute;
  bottom: 0;
  right: 5%;
}

.content_left_shu {
  width: 550px;
  height: 40px;
  margin-top: 30px;
}

.input2 {
  width: 120px;
  margin: 10px 0 0 15px;
  float: left;
  z-index: 0;
}

.content_left_gou {
  width: 200px;
  height: 44px;
  margin: 0 0 0 55px;
}

.content_left_pingj {
  width: 100%;
  height: 48px;
  background: #e4e4e4ff;
  display: flex;
}

.content_left_pingj p {
  width: 180px;
  height: 48px;
  text-align: center;
  line-height: 48px;
  color: #666666ff;
}

.content_left_2p {
  font-size: 14px;
  margin: 20px 0 0 19px;
  color: #666666ff;
}

.content_left_2bot {
  width: 900px;
  height: 1639px;
  margin: 19px auto;
}

.content_left_2bot img {
  width: 100%;
}

.content_left_pingj p.active {
  background: #fff;
  border-top: 4px solid #007bffff;
  color: #007bffff;
}

.content_left_pingj2 {
  width: 900px;
  height: 80px;
  margin: 30px auto;
  position: relative;
}

.content_left_jifen {
  width: 97px;
  height: 80px;
  background: #ffab1dff;
  float: left;
}

.jfen_p {
  width: 49px;
  height: 53px;
  font-size: 24px;
  margin: 0 auto;
  line-height: 39px;
  color: #fff;
}

.jfen_img {
  position: absolute;
  top: 100%;
  margin-top: -50px;
  left: 97px;
}

.jfen_div {
  width: 783px;
  height: 80px;
  float: right;
  background: rgba(255, 171, 29, 0.05);
}

.jfen_xinxin {
  width: 120px;
  height: 60px;
  margin: 10px 0 0 50px;
  float: left;
}

.jfen_xinxin p {
  font-size: 24px;
  font-weight: bold;
  color: rgba(255, 171, 29, 1);
  line-height: 40px;
  text-align: center;
}

.oimg {
  margin-left: 15px;
}

.jfen_ul li {
  float: left;
  line-height: 90px;
  margin-left: 70px;
  font-size: 14px;
}

.jfen_ul li span {
  color: #ffab1dff;
}

.content_left_guzhu {
  width: 900px;
  height: 90px;
  margin: 30px auto;
  border-bottom: 1px solid #e4e4e4ff;
}

.guzhu_p {
  font-weight: 900;
  font-size: 14px;
  line-height: 20px;
}

.guzhu_ul li {
  float: left;
  margin-top: 15px;
  background: #f5f6faff;
  padding: 10px;
  margin-left: 16px;
  border-radius: 5px;
  font-size: 12px;
  color: #666666ff;
}
.guzhu_ul li:first-child {
  margin-left: 5px;
}

.content_left_pinglou {
  width: 900px;
  height: 120px;
  border-bottom: 1px solid #e4e4e4ff;
  margin: 55px auto;
}

.content_left_pinglou1 {
  width: 97px;
  height: 80px;
  float: left;
}

.pinglou_img {
  width: 40px;
  height: 40px;
  background: #000;
  margin: 0 auto;
  border-radius: 25px;
  margin-top: 10px;
}

.pinglou_img img {
  width: 40px;
  height: 40px;
  border-radius: 25px;
}

.content_left_pinglou1 p {
  font-size: 12px;
  text-align: center;
  margin-top: 10px;
}
.pinglou_ul {
  width: 781px;
  float: left;
}

.pinglou_ul li {
  margin-left: 35px;
  font-size: 12px;
  color: #999999ff;
  margin-top: 10px;
}

.content_three_1 {
  width: 900px;
  height: 100px;
  margin: 0 auto;
  background: #fff;
  overflow: hidden;
}

.fenye {
  text-align: center;
}

.zantu {
  width: 900px;
  height: 600px;
}
.zantu img {
  margin: 98px 0 0 406px;
}

.zantu p {
  text-align: center;
  line-height: 80px;
}

.content_left_2bot img {
  width: 100%;
}

.guige li.active {
  border: 1px solid #f7681eff;
}

.guige li.active img {
  display: block;
}

/* denglu */
.login1 {
  width: 340px;
  height: 50px;
  margin: 0 auto;
}

.login1 div {
  width: 170px;
  height: 40px;
  font-size: 18px;
  float: left;
  text-align: center;
  font-weight: bold;
  border-bottom: 2px solid #e4e4e4;
}

.login1 div a {
  color: #a9a9a9;
}

.login1 div.active {
  border-bottom: 2px solid #007bff;
}

.login1 div.active a {
  color: #007bff;
}

.login1_1 {
  width: 100%;
  height: 399px;
  position: relative;
  overflow: hidden;
}

.login1_img {
  position: absolute;
  right: 0;
  bottom: 0;
}

.login1_2 {
  width: 604px;
  height: 239px;
  margin: 50px auto;
}

.login1_2_left {
  width: 332px;
  height: auto;
  float: left;
}

.login1_2_erro {
  width: 322px;
  height: 30px;
  border: 1px solid#FF4D42;
  background: rgba(255, 77, 66, 0.1);
  line-height: 30px;
  margin-bottom: 16px;
}

.login1_2_erro1 {
  width: 322px;
  height: 30px;
  margin-bottom: 16px;
}

.login1_2_erro img {
  float: left;
  padding: 5px 9px;
}

.login1_2_login {
  width: 322px;
  height: 168px;
}

.inp {
  width: 210px;
  height: 40px;
  font-size: 14px;
  float: left;
  outline: 0;
  border: 0;
  margin: 0 5px;
}

.login1_2_tel {
  width: 100%;
  height: auto;
  margin-bottom: 30px;
  position: relative;
}

.inpt {
  width: 312px;
  height: 38px;
  outline: 0;
  font-size: 14px;
  border: 0;
  margin: 0 5px;
}

.login1_2_right {
  float: right;
  background: #000;
  width: 228px;
  height: 239px;
}

.login1_2_denglu {
  width: 100%;
  height: 40px;
  background: #007bff;
  margin-top: 32px;
}

.login1_2_denglu p {
  text-align: center;
  font-size: 16px;
  line-height: 40px;
}

.login1_2_denglu p a {
  color: #fff;
}
.code-btn {
  width: 100px;
  height: 20px;
  position: absolute;
  top: 10px;
  right: 5px;
  z-index: 222;
  color: #007bff;
  font-size: 14px;
  border: none;
  border-left: 1px solid #bababa;
  padding-left: 10px;
  background-color: #fff;
  cursor: pointer;
  outline: none;
}
.pr {
  margin-bottom: 20px;
}

.login2_1_one {
  width: 322px;
  height: 550px;
  margin: 20px auto;
}

.login_three {
  width: 100%;
  height: 20px;
  margin-bottom: 20px;
}

.login_three img {
  float: left;
  padding: 0 5px 0 0;
}

.login_three p {
  float: left;
  line-height: 15px;
}

.top_ul li a {
  color: #666666;
}

.floor_china_1 li a {
  color: #85919a;
  font-size: 14px;
}

.top_show {
  width: 100%;
  height: 280px;
  background: #fff;
  position: absolute;
  top: 184px;
  left: 0;
  position: fixed;
  display: none;
}

.hover_li:hover .top_show {
  display: block;
}

.top_show_1 {
  width: 700px;
  height: 164px;
  margin: 34px auto;
}

.top_show_1 li {
  width: 220px;
  height: 72px;
  float: left;
  margin: 10px 0 0 10px;
  border-radius: 4px;
  line-height: 25px;
  overflow: hidden;
}

.top_show_1 li:hover {
  background: #f4f5f9ff;
}

.top_show_1 li p a {
  /* padding: 5px 5px 0 5px; */
  font-size: 14px;
  color: #999999ff;
  text-align: left;
}

.top_show_1 li p:first-child {
  border-left: 5px solid #007bff;
  border-radius: 0;
  margin: 10px 0 10px 0;
}

.top_show_1 li p:first-child a {
  width: auto;
  height: 19px;
  font-size: 18px;
  color: #222222ff;
  margin: 10px 0 10px 0;
  text-align: left;
}

.koa {
  width: auto;
  text-align: center;
  margin-top: -5px;
  margin-left: 20px;
}

.top_p p {
  float: left;
  padding: 0 12px;
  line-height: 40px;
  font-size: 14px;
}

.top_cent_p {
  color: #007bffff;
}

.icon {
  color: #000;
}

.aa {
  color: #222222ff;
}
</style>



// WEBPACK FOOTER //
// src/view/Fuwu/Fuwuxiang.vue